<template>
  <div class="c-retarget">
    <Row :gutter="12">
      <Col span="12">
        <div class="c-retarget-box">
          <div class="c-retarget-head g-clearfix">
            <span class="c-retarget-title">{{ title }}</span>
            <span class="c-retarget-attr">ID</span>
            <span class="c-retarget-attr">{{ attribe }}</span>
            <span class="c-tag-icon"
              >定向<Icon
                v-if="attrSelectAll('include')"
                type="ios-checkbox"
                color="#2d8cf0"
                :size="16"
                @click="changeRetargetAll('includes', false)" /><Icon
                v-else
                type="ios-square-outline"
                color="#dcdee2"
                :size="16"
                @click="changeRetargetAll('includes', true)"
            /></span>
            <span class="c-tag-icon"
              >排除<Icon
                v-if="attrSelectAll('exclude')"
                type="ios-checkbox"
                color="#2d8cf0"
                :size="16"
                @click="changeRetargetAll('excludes', false)" /><Icon
                v-else
                type="ios-square-outline"
                color="#dcdee2"
                :size="16"
                @click="changeRetargetAll('excludes', true)"
            /></span>
          </div>
          <div class="c-retartget-content" style="overflow-y: scroll">
            <div class="c-check-item g-clearfix" v-for="item in data" :key="item.id">
              <span class="item-span">{{ item.name }}</span>
              <RadioGroup v-model="item.select" style="float: right; height: 36px">
                <Radio label="include"></Radio>
                <Radio label="exclude" :disabled="item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'"></Radio>
              </RadioGroup>
              <span class="item-type">{{ attriVal(item) }}</span>
              <span class="item-id">{{ item.id }}</span>
              <span class="m-cataract c-include" @click.stop="selectItem(item, 'include')"></span>
              <span v-if="item.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'" class="m-cataract c-exclude c-disabled"></span>
              <span v-else class="m-cataract c-exclude" @click.stop="selectItem(item, 'exclude')"></span>
            </div>
          </div>
        </div>
      </Col>
      <Col span="8" offset="2">
        <div v-if="resultLen" class="c-retarget-box">
          <span class="c-retarget-clear" @click="$emit('on-clear', { list: data })">清空全部</span>
          <Tabs :value="currenTab" size="small">
            <TabPane :label="`定向${includes.length ? '(' + includes.length + ')' : ''}`" class="c-retarget-result" name="include">
              <Tag v-for="item in includes" :key="item.id" :name="item.name" closable class="c-tag-item" @on-close="handleClose">{{
                item.name
              }}</Tag>
            </TabPane>
            <TabPane :label="`排除${excludes.length ? '(' + excludes.length + ')' : ''}`" class="c-retarget-result" name="exclude">
              <Tag v-for="item in excludes" :key="item.id" :name="item.name" closable class="c-tag-item" @on-close="handleClose">{{
                item.name
              }}</Tag>
            </TabPane>
          </Tabs>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'retarget',
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    media: {
      type: Number
    },
    currenTab: {
      type: String,
      default() {
        return 'include'
      }
    }
  },
  computed: {
    resultLen() {
      return this.data.filter((ret) => ret.select === 'include' || ret.select === 'exclude').length
    },
    includes() {
      return this.data.filter((ret) => ret.select === 'include')
    },
    excludes() {
      return this.data.filter((ret) => ret.select === 'exclude')
    },
    attribe() {
      if (this.media === 16) return '覆盖数量'
      else return '属性'
    },
    attriVal() {
      return (item) => {
        let type
        switch (item.type) {
          case 'CUSTOMIZE':
            type = '自定义'
            break
          case 'FEATURED':
            type = '运营推荐'
            break
          case 'SYSTEM':
            type = '系统推荐'
            break
          default:
            type = '未知'
            break
        }
        return type
      }
    },
    attrSelectAll() {
      return (select) => {
        const bool = isArray(this.data) && this.data.length
        if (select === 'exclude') {
          return (
            bool && this.data.filter((ret) => ret.source !== 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY').every((ret) => ret.select === 'exclude')
          )
        } else if (select === 'include') return bool && this.data.every((ret) => ret.select === 'include')
      }
    }
  },
  methods: {
    handleClose(event, name) {
      this.$emit('on-delete', { list: this.data, name })
    },
    selectItem(item, type) {
      const someOne = this.data.some((ret) => {
        const iType = type === 'exclude' ? 'include' : 'exclude'
        return ret.select === iType
      })
      if (someOne) {
        this.$Modal.confirm({
          title: '确认更改选项',
          content: '媒体定向不支持同时定向且排除操作，更换操作类型后已选流量包会被清空，是否继续？',
          onOk: () => {
            this.$emit('on-clear', { list: this.data })
            this.$emit('on-select', { list: this.data, item, type })
          }
        })
      } else {
        this.$emit('on-select', { list: this.data, item, type })
      }
    },
    changeRetargetAll(type, check) {
      const bool = Boolean(check)
      if (isArray(this.data) || this.data.length) {
        this.data.forEach((ret) => {
          const disbool = type === 'excludes' && ret.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'
          this.$set(ret, 'select', bool && !disbool ? type.substr(0, type.length - 1) : null)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-retarget-box {
  position: relative;
  background-color: #fafbfe;
  border: solid 1px #dee4f5;

  .c-retarget-head {
    padding: 0 8px 0 12px;
    height: 34px;
    text-align: right;
    color: #333;
    border-bottom: solid 1px #dee4f5;

    span {
      height: 34px;
      font-size: 12px;
      line-height: 34px;
      vertical-align: middle;
      margin-left: 8px;
    }

    .c-retarget-title {
      float: left;
      font-size: 14px;
      margin-left: 0;
    }

    .c-retarget-attr {
      display: inline-block;
      margin-right: 6px;
      width: 48px;
    }

    .c-tag-icon {
      margin-right: 0;

      .ivu-icon {
        cursor: pointer;
        margin: 0 0 0 3px;
      }
    }
  }

  .c-retartget-content,
  .c-retarget-result {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 246px;
    background-color: #fff;

    .c-check-item {
      margin: 0;
      padding-left: 12px;
      display: block;
      position: relative;
      height: 36px;
      line-height: 36px;

      &:hover {
        background-color: #f8f8f8;
      }

      .ivu-radio-wrapper {
        min-width: inherit;
        text-align: right;
        font-size: 0;
        margin-right: 14px;
      }

      .item-span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        width: 215px;
        display: inline-block;
      }

      .item-type,
      .item-id {
        float: right;
        text-align: right;
      }

      .item-type {
        width: 50px;
        margin-right: 22px;
      }

      .item-id {
        width: 60px;
        margin-right: 10px;
      }

      .m-cataract {
        position: absolute;
        width: 18px;
        height: 36px;
        cursor: pointer;
        user-select: none;
        top: 0;
        z-index: 2;

        &.c-disabled {
          cursor: not-allowed;
        }
      }

      .c-include {
        right: 48px;
      }

      .c-exclude {
        right: 16px;
      }
    }
  }

  .c-retarget-clear {
    width: 60px;
    height: 34px;
    line-height: 34px;
    position: absolute;
    z-index: 8;
    right: 0;
    top: 0;
    display: block;
    color: #598fe6;
    text-align: center;
    cursor: pointer;
  }

  .c-retarget-result {
    padding-bottom: 8px;
  }
}

.c-tag-item {
  margin: 8px 12px 0;
  padding: 2px 6px;
  display: block;
  font-size: 14px;
  height: 28px;
}
</style>
